<div class="horarios_btns">
    <ul class="reservas-list" *ngFor="let reserva of itensHorarios">
        <li class="reservado" [style.background-color]="reserva.corTerapeuta" [style.color]="isColorLight(reserva.corTerapeuta) ? 'black' : 'white'" [ngbTooltip]="reserva.paciente">{{tratarNome(reserva.paciente)}}</li>
        <li class="reservado-delete" (click)="removerReserva(reserva.id)">❌</li>
    </ul>

    <ul class="add-buttons">
        <li (click)="abrirModalReserva()" *ngFor="let _ of [].constructor(horariosVagos())">+</li>
    </ul>
</div>